import axios from 'axios';
import axiosRetry from 'axios-retry';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import toastr from 'toastr';
const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getAdminSetting = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_ADMIN_SETTING,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`/api/app/Configuracion_Actualizacion_Empleado/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_ADMIN_SETTINGS,
      payload: resp.data[0]
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_ADMIN_SETTING,
      payload: false
    });
  }
}

export const updateStateAdminSettings = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.UPDATE_ADMIN_SETTINGS,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(`/api/app/Actualizacion_Datos_Excel_cambio_estado/`,data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    if(resp.statusText==="OK"){
      dispatch(exportDataToExcel());
    }
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.UPDATE_ADMIN_SETTINGS,
      payload: false
    });
  }
}

export const saveAdminSetting = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SAVE_ADMIN_SETTINGS,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post('/api/app/Configuracion_Actualizacion_Empleado/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    dispatch({
      type: actions.GET_ADMIN_SETTINGS,
      payload: resp.data
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_SAVE_ADMIN_SETTINGS,
      payload: false
    });
  }
}

export const editAdminSetting = (data, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SAVE_ADMIN_SETTINGS,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(`/api/app/Configuracion_Actualizacion_Empleado/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});

    dispatch({
      type: actions.GET_ADMIN_SETTINGS,
      payload: resp.data
    });
    
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_SAVE_ADMIN_SETTINGS,
      payload: false
    });
  }
}

export const exportDataToExcel = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.EXPORT_LOADER_DATA_EXCEL,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};

    const resp = await client.get(`/api/app/Actualizacion_Datos_Excel/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    dispatch({
      type: actions.EXPORT_DATA_TO_EXCEL,
      payload: resp.data
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.EXPORT_LOADER_DATA_EXCEL,
      payload: false
    });
  }
}